import React from "react";
import { AppLauncher } from "@capacitor/app-launcher";
import "./NotificationsOffPopup.css";
import { t } from "../i18n";

// Shown when a talent taps "Don't Allow" on Apple's one-shot
// push-permission prompt (and when they flip the settings toggle ON while the
// OS permission is denied). Apple never re-shows its prompt, so the green CTA
// deep-links straight to the app's page in iPhone Settings. Design approved
// via a Chrome gallery.
//
// The copy props exist so other blocked-OS-permission moments (photo-library
// access, item 3) reuse the same approved look; defaults stay the
// notifications wording.
interface Props {
  open: boolean;
  onClose: () => void;
  emoji?: string;
  title?: string;
  sub?: string;
}

// Also the Face ID row's way to iPhone Settings (FaceIdSettingRow).
export const openIOSSettings = async () => {
  try {
    // "app-settings:" = Apple's sanctioned URL for our own app's Settings page.
    await AppLauncher.openUrl({ url: "app-settings:" });
  } catch {
    // Nothing sane to do if Settings won't open — the popup copy already told
    // them where notifications live.
  }
};

const NotificationsOffPopup: React.FC<Props> = ({
  open,
  onClose,
  emoji,
  title = t("notificationsOffPopup.notificationsAreOff"),
  sub = t("notificationsOffPopup.youWonTHear"),
}) => {
  if (!open) return null;
  return (
    <div className="notifoff-overlay" role="dialog" aria-modal="true" aria-labelledby="notifoff-title">
      <div className="notifoff-card">
        <div className="notifoff-emoji" aria-hidden="true">
          {/* Default = a Brand Green line bell (no Apple emoji in product UI);
              other permission moments still pass their own glyph. */}
          {emoji ?? (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#24C961" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M8.7 3.9A6 6 0 0 1 18 9c0 2.7.6 4.6 1.3 5.9" /><path d="M17.5 17H4.5c1-1.3 1.5-3.5 1.5-8a6 6 0 0 1 .3-1.9" /><path d="M10 20.5a2 2 0 0 0 4 0" /><path d="M3 3l18 18" />
            </svg>
          )}
        </div>
        <div className="notifoff-title" id="notifoff-title">{title}</div>
        <p className="notifoff-sub">{sub}</p>
        <button
          type="button"
          className="notifoff-cta"
          onClick={() => {
            openIOSSettings();
            onClose();
          }}
        >
          {t("notificationsOffPopup.turnOnInSettings")}
        </button>
        <button type="button" className="notifoff-ghost" onClick={onClose}>
          {t("notificationsOffPopup.notNow")}
        </button>
      </div>
    </div>
  );
};

export default NotificationsOffPopup;
